import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import type { FeatureKey } from '../types';
import { canAccessFeatureFromSnapshot } from '../lib/feature-access';

function LoadingSpinner() {
  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: 'var(--color-surface-0)' }}
    >
      <div
        className="animate-spin rounded-full h-10 w-10 border-2 border-transparent"
        style={{
          borderTopColor: 'var(--color-accent)',
          borderBottomColor: 'var(--color-accent)',
        }}
      />
    </div>
  );
}

export function FeatureRoute({
  feature,
  children,
}: {
  feature: FeatureKey;
  children: React.ReactNode;
}) {
  const { loading, featureAccess } = useAuth();

  if (loading) return <LoadingSpinner />;
  if (!canAccessFeatureFromSnapshot(featureAccess, feature)) {
    return <Navigate to={`/?unavailable=${feature}`} replace />;
  }

  return <>{children}</>;
}

export function SuperAdminRoute({ children }: { children: React.ReactNode }) {
  const { loading, isSuperAdmin } = useAuth();

  if (loading) return <LoadingSpinner />;
  if (!isSuperAdmin) return <Navigate to="/" replace />;
  return <>{children}</>;
}
